var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 17V15.2222C14 14.2792 13.6087 13.3749 12.9121 12.7081C12.2155 12.0413 11.2708 11.6667 10.2857 11.6667H4.71429C3.7292 11.6667 2.78445 12.0413 2.08789 12.7081C1.39133 13.3749 1 14.2792 1 15.2222V17M11.2143 4.55556C11.2143 6.51923 9.55134 8.11111 7.5 8.11111C5.44866 8.11111 3.78571 6.51923 3.78571 4.55556C3.78571 2.59188 5.44866 1 7.5 1C9.55134 1 11.2143 2.59188 11.2143 4.55556Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserblack);
export default __webpack_public_path__ + "static/media/userblack.f2377c8c9b719bab8d43cb6a88e5d8de.svg";
export { ForwardRef as ReactComponent };